export default __webpack_public_path__ + "static/media/netflixLogin.774e8c16.png";